import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchReactionTypes = () =>
  HttpClient().get('/reactions/v2/reaction_types')

const getReactionTypes = () => (dispatch) =>
  fetchReactionTypes()
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getReactionTypes
